'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = function (_Component) {
  (0, _inherits3.default)(SearchBar, _Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit(event);
      return false;
    }, _this.getSectionSuggestions = function (section) {
      return section.data;
    }, _this.getSuggestionValue = function (suggestion) {
      return suggestion[_this.props.labelKey];
    }, _this.shouldRenderSuggestions = function (value) {
      return value.trim().length > _this.props.minLength;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          buttonText = _props.buttonText,
          minLength = _props.minLength,
          onChange = _props.onChange,
          onClear = _props.onClear,
          onFetch = _props.onFetch,
          onSelect = _props.onSelect,
          paramKey = _props.paramKey,
          placeholder = _props.placeholder,
          query = _props.query,
          renderSectionTitle = _props.renderSectionTitle,
          renderSuggestion = _props.renderSuggestion,
          suggestions = _props.suggestions;


      var inputProps = {
        name: paramKey,
        onChange: onChange,
        placeholder: placeholder,
        value: query
      };

      var theme = {
        container: 'container',
        containerOpen: 'containerOpen',
        input: 'input',
        sectionContainer: 'sectionContainer',
        sectionTitle: 'sectionTitle',
        suggestion: 'suggestion',
        suggestionHighlighted: 'suggestionFocused',
        suggestionsContainer: 'suggestionsContainer',
        suggestionsList: 'suggestionsList'
      };

      return _react2.default.createElement(
        'form',
        { className: 'SearchBar', onSubmit: this.onSubmit, action: '/evenements', method: 'get' },
        _react2.default.createElement(
          'div',
          { className: 'icon-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'icon' },
            _react2.default.createElement(_.Icon, { name: 'search' })
          ),
          _react2.default.createElement(_reactAutosuggest2.default, {
            suggestions: suggestions,
            multiSection: true,
            onSuggestionSelected: onSelect,
            onSuggestionsFetchRequested: onFetch,
            onSuggestionsClearRequested: onClear,
            getSuggestionValue: this.getSuggestionValue,
            getSectionSuggestions: this.getSectionSuggestions,
            renderSuggestion: renderSuggestion,
            renderSectionTitle: renderSectionTitle,
            shouldRenderSuggestions: this.shouldRenderSuggestions,
            alwaysRenderSuggestions: minLength === 0,
            inputProps: inputProps,
            theme: theme
          })
        ),
        _react2.default.createElement(
          'button',
          { type: 'submit' },
          buttonText
        )
      );
    }
  }]);
  return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
  /**
   * Text to display on the submit button (adaptive behaviour, not actually displayed)
   */
  buttonText: _propTypes2.default.string,
  /**
   * Object key to use to get the suggestion label
   */
  labelKey: _propTypes2.default.string,
  /**
   * Minimal length before the search endpoint is queried
   */
  minLength: _propTypes2.default.number,
  /**
   * Mandatory method to update the input value
   */
  onChange: _propTypes2.default.func.isRequired,
  /**
   * Mandatory method called when the suggestions should be cleared
   */
  onClear: _propTypes2.default.func.isRequired,
  /**
   * Mandatory method called when the suggestions should be fetched
   */
  onFetch: _propTypes2.default.func.isRequired,
  /**
   * Mandatory method called when a suggestion is selected
   */
  onSelect: _propTypes2.default.func.isRequired,
  /**
   * Mandatory method called when the form is submitted
   */
  onSubmit: _propTypes2.default.func.isRequired,
  /**
   * Key to associate to the search input
   */
  paramKey: _propTypes2.default.string,
  /**
   * Placeholder text to display in the search input
   */
  placeholder: _propTypes2.default.string,
  /**
   * Current value of the search input
   */
  query: _propTypes2.default.string,
  /**
   * Optional method that returns a string or HTML to display a
   * section title (for adaptive design, not displayed)
   */
  renderSectionTitle: _propTypes2.default.func,
  /**
   * Optional method that returns a string or HTML representing
   * a single suggestion item
   */
  renderSuggestion: _propTypes2.default.func.isRequired,
  /**
   * The array of suggestions
   */
  suggestions: _propTypes2.default.array.isRequired
};
SearchBar.defaultProps = {
  buttonText: 'Rechercher',
  labelKey: 'label',
  minLength: 2,
  paramKey: 'q',
  placeholder: 'Événement, thème, lieu…',
  query: '',
  renderSectionTitle: function renderSectionTitle(section) {
    return section.meta.type;
  }
};
exports.default = SearchBar;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SearchBar.js
// module id = 283
// module chunks = 0